import { themeObject } from '../../lib';

export const METADATA_STORAGE_KEY = 'metadata-search';

export const METADATA_SEARCH = {
    PAGE_TITLE: 'Global Search',
    IMAGE_HEADING_TEXT: 'Enter search term(s) below',
    IMAGE_SUBHEADING_TEXT:
        'Enter one or more search terms separated by commas.',
};

export const metadataSearchStyles = {
    pageContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        overflow: 'auto',
    },
    titleContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        mb: 2.5,
        ml: 3.875,
        mt: 3,
    },
    titleContainerResults: {
        mb: 1.5,
    },
    pageTitleText: {
        ...themeObject.typography.titleCopy,
        color: themeObject.palette.primary[700],
    },
    bodyContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 200px)',
        mb: 3,
        mt: 2.5,
        mx: 44.25,
        alignItems: 'center',
        justifyContent: 'center',
    },
    contentContainer: {
        width: '430px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    emptyStateImage: {
        height: '149.54px',
        width: '272.8px',
    },
    headingTextContainer: {
        mt: 4,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    termsHeadingText: {
        ...themeObject.typography.h2,
        fontSize: '26px',
        lineHeight: '30.52px',
        color: themeObject.palette.primary[700],
    },
    subHeadingTextContainer: {
        mt: 2,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    termsSubheadingText: {
        ...themeObject.typography.body1,
        color: themeObject.palette.grayScale[700],
        textAlign: 'center',
    },
    searchFieldContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        mt: 4,
    },
    autocomplete: {
        '& .MuiFormControl-root': {
            width: '365px',
            height: '41px',
        },
    },
    autocompleteTextArea: {
        '& .MuiInputBase-input': {
            height: '37px',
        },
    },
    buttonContainer: {
        ml: 1,
        mr: 0.8125,
    },
    button: {
        width: '44px',
        height: '41px',
        minWidth: 0,
        padding: 0,
    },
};
